import { TextField, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { LocationIcon } from 'components/core/location_icon'
import { ConfigurableItemCard } from 'features/event_type_editor_crud/components/configurable_item_card'

import { iconSizeCss } from './styles'

export const PhysicalLocationCard = ({
  fieldNamePrefix,
  subtitle,
  onDelete,
  onCancel,
  onDone,
}) => {
  const [{ value: locationValue }] = useFormField({ name: `${fieldNamePrefix}.location` })

  return (
    <ConfigurableItemCard
      icon={<LocationIcon useCrudIcons kind="physical" size="x-large" className={iconSizeCss} />}
      title={I18n.t('publisher.event_type_editor_crud.meeting_details.location.physical_card_title')}
      subtitle={subtitle}
      deleteLabel={I18n.t('publisher.action.remove')}
      onDelete={onDelete}
      onCancel={onCancel}
      onDone={onDone}
      isDoneDisabled={!locationValue?.trim()}
    >
      <TextField
        name={`${fieldNamePrefix}.location`}
        label={I18n.t('publisher.event_type_editor_crud.meeting_details.location.location_field_label')}
        placeholder={I18n.t('publisher.event_type_editor_crud.meeting_details.location.location_field_placeholder')}
        size="medium"
        required
        requiredMark="asterisk"
        maxLength={255}
        errorOnInputOnly
      />
      <TextField
        name={`${fieldNamePrefix}.additionalInfo`}
        label={I18n.t('publisher.event_type_editor_crud.meeting_details.location.note_field_label')}
        placeholder={I18n.t('publisher.event_type_editor_crud.meeting_details.location.note_field_placeholder')}
        size="medium"
        type="textarea"
        requiredMark="optional"
        maxLength={255}
      />
    </ConfigurableItemCard>
  )
}
